<div class="wa-flank:start">
  <div class="button-group-toolbar">
  <wa-button (click)="unexclude.emit(staffmember())" appearance="plain" label="to regular pool" size="s"
               variant="warning">
      <wa-icon name="left-from-line" variant="classic"></wa-icon>
    </wa-button>
    </div>
  <div>{{ staffmember().last_name }}, {{ staffmember().first_name }}</div>
</div>
